import { render, staticRenderFns } from "./FilterCook.vue?vue&type=template&id=2bbd109f&scoped=true&"
import script from "./FilterCook.vue?vue&type=script&lang=js&"
export * from "./FilterCook.vue?vue&type=script&lang=js&"
import style0 from "./FilterCook.vue?vue&type=style&index=0&id=2bbd109f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbd109f",
  null
  
)

export default component.exports